<div class="addContainer">
  <div class="modalHeader">
    <button (click)="dialogRef.close()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="mt-4" mat-dialog-content>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="card">
        <div class="materialTableHeader">
          <div class="left">
            <ul class="header-buttons-left ms-0">
              <li class="tbl-search-box">
                <label><i class="material-icons search-icon">search</i></label>
                <input
                  #filter
                  aria-autocomplete="none"
                  aria-label="Search box" autocomplete="nope" class="browser-default search-field"
                  placeholder="BUSCAR"
                  type="text">
              </li>
            </ul>
          </div>
          <div class="right">
            <ul class="tbl-export-btn">
              <li class="tbl-header-btn">
                <div class="m-l-10" matTooltip="RECARGAR">
                  <button (click)="refresh()" color="primary" mat-mini-fab>
                    <mat-icon>refresh</mat-icon>
                  </button>
                </div>
              </li>
              <li>
                <div class="export-button m-l-10" matTooltip="EXCEL">
                  <img (click)="exportExcel()" alt="" height="512" ngSrc="assets/images/icons/xlsx.png" width="512"/>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="body overflow-auto">
          <div class="responsive_table">
            <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

              <ng-container matColumnDef="idPaciente">
                <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
                <mat-cell *matCellDef="let row" matTooltip="{{row.idEvento}}">{{ row.idEvento }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="evento">
                <mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</mat-header-cell>
                <mat-cell *matCellDef="let row" matTooltip="{{row.nombreEvento}}"><span
                  class="mobile-label">Nombre:</span>{{ row.nombreEvento }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="fecha">
                <mat-header-cell *matHeaderCellDef mat-sort-header>FECHA</mat-header-cell>
                <mat-cell *matCellDef="let row" matTooltip="{{row.fecha}}"><span
                  class="mobile-label">Fecha:</span>{{ row.fecha }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="descripcion">
                <mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPCION</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index;" class="pr-0">
                  <span class="mobile-label">Descripcion:</span>
                  <button
                    (click)="$event.stopPropagation(); showDescription(row)"
                    class="tbl-fav-std"
                    mat-icon-button>
                    <app-feather-icons [icon]="'layers'"></app-feather-icons>
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
              </mat-row>
            </table>
            <!-- Loading spinner -->
            @if (data?.isTblLoading) {
              <div class="tbl-spinner">
                <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
                </mat-progress-spinner>
              </div>
            }
            @if (!data?.isTblLoading) {
              <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
                SIN RESULTADOS
              </div>
            }
            <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0"
                           [pageSizeOptions]="[5, 10, 25, 100]"
                           [pageSize]="10">
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


